import React, { useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Pin, Loader2 } from "lucide-react";
import { formatDistanceToNow } from "date-fns";
import showcaseApi from "../../lib/showcaseApi";
import NotesInboxDialog from "./NotesInboxDialog";
import { ProductDescriptionsDialog } from "./ProductDescriptionsDialog";
import { HiddenItemsDialog } from "./HiddenItemsDialog";

export const PresentationPinBar = ({ pin, onPinned, onDescriptionChanged }) => {
  const [busy, setBusy] = useState(false);
  const exists = pin && pin.exists;
  let rel = "";
  try {
    if (exists && pin.pinned_at) rel = formatDistanceToNow(new Date(pin.pinned_at), { addSuffix: true });
  } catch (e) {}

  const drop = async () => {
    setBusy(true);
    try {
      await showcaseApi.pin();
      toast.success("Pinned for the team. New items will be flagged from here.");
      if (onPinned) await onPinned();
    } catch (e) {
      toast.error("We couldn't set the pin. Please try again.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div
      className="showcase-card flex flex-col sm:flex-row sm:items-center justify-between gap-3 px-4 py-3"
      data-testid="presentation-pin-bar"
    >
      <div className="flex items-start gap-2.5 min-w-0">
        <span
          className="inline-flex items-center justify-center w-8 h-8 rounded-full shrink-0"
          style={{ background: exists ? "rgba(15,118,110,0.12)" : "rgba(63,79,102,0.08)" }}
        >
          <Pin size={16} style={{ color: exists ? "#0F766E" : "#3F4F66" }} />
        </span>
        <div className="min-w-0">
          {exists ? (
            <p className="text-sm text-foreground leading-snug" data-testid="pin-status">
              <span className="font-semibold">Pinned for the team {rel}.</span>{" "}
              Anything new since then is flagged <span style={{ color: "#0F766E", fontWeight: 600 }}>New</span>.
            </p>
          ) : (
            <p className="text-sm text-foreground leading-snug" data-testid="pin-status">
              <span className="font-semibold">Not pinned yet.</span> Drop a pin when you present, so next time we can
              show you what's changed since.
            </p>
          )}
        </div>
      </div>
      <div className="flex flex-wrap items-center gap-2 shrink-0">
        <NotesInboxDialog />
        <ProductDescriptionsDialog onDescriptionChanged={onDescriptionChanged} />
        <HiddenItemsDialog />
        <Button onClick={drop} disabled={busy} size="sm" className="gap-1.5" data-testid="pin-button">
          {busy ? <Loader2 size={15} className="animate-spin" /> : <Pin size={15} />}
          {exists ? "Update pin" : "Pin for the team"}
        </Button>
      </div>
    </div>
  );
};

export default PresentationPinBar;
